import React, { useMemo } from 'react';
import styled from 'styled-components';

import colors from 'utils/colors';
import device from 'utils/device';

import Feedback from './Feedback';
import Link, { ComponentProps as LinkProps } from './Link';

export type ComponentProps = Record<string, never>;

const sitemapButtonsData: LinkProps[] = [
  { text: 'Our Services', link: 'https://service.vic.gov.au/find-services' },
  { text: 'Careers', link: 'https://careers.vic.gov.au/jobs/premier-and-cabinet/service-victoria' },
  { text: 'Accessibility', link: 'https://service.vic.gov.au/accessibility' },
  { text: 'Terms of use', link: 'https://service.vic.gov.au/terms-of-use' },
  { text: 'Copyright', link: 'https://service.vic.gov.au/copyright' },
  { text: 'Privacy and security', link: 'https://service.vic.gov.au/privacy-and-security' }
];

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid ${colors.darkGrey75};

  @media ${device.isTablet} {
    width: 95vw;
    align-items: stretch;
    justify-content: center;
    flex-wrap: unset;
  }

  @media ${device.isDesktop} {
    width: 960px;
    margin: auto;
  }
`;

const LinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  transform: translateY(1px);

  padding: 40px 20px;
  line-height: 1.05rem;
  border-bottom: 1px solid ${colors.darkGrey75};

  @media ${device.isTablet} {
    padding: 0;
    flex: 0 50%;
    flex-wrap: wrap;
    padding: 5rem 0 2rem;
  }

  @media ${device.isDesktop} {
    padding: 6rem 0 3rem 0;
  }
`;

const FeedBackContainer = styled.div`
  transition: all 0.1s ease-in-out;
  background: transparent;
  transition: color 0.1s ease-in-out;
  outline-color: ${colors.white};
  padding: 20px;

  @media ${device.isTablet} {
    padding: 0;
    flex: 0 50%;
    padding: 5rem 0 2rem;
  }

  @media ${device.isDesktop} {
    padding: 6rem 0 3rem 3rem;
  }
`;

const Footer: React.FC<ComponentProps> = () => {
  const links = useMemo(() => {
    return sitemapButtonsData.map(({ link, text }) => <Link link={link} text={text} key={text} />);
  }, []);
  return (
    <Wrapper>
      <LinksContainer>{links}</LinksContainer>
      <FeedBackContainer>
        <Feedback
          title='Give feedback'
          subtitle='Tell us about your experience'
          link='https://service.vic.gov.au/contact/send-us-a-message'
        />
      </FeedBackContainer>
    </Wrapper>
  );
};

export default Footer;
